import { ActionTypes } from './action-types.enum';

export const addImages = (content) => ({
  type: ActionTypes.ADD_IMAGES,
  payload: {
    images: content.images,
    categoryId: content.id,
  }
});

export const addImage = (content) => ({
  type: ActionTypes.ADD_IMAGE,
  payload: {
    image: content.image,
  }
});

export const addUploadedImage = (content) => ({
  type: ActionTypes.ADD_UPLOADED_IMAGE,
  payload: {
    fileId: content.fileId,
    image: content.image,
  }
});

export const addUploadingImages = (content) => ({
  type: ActionTypes.ADD_UPLOADING_IMAGES,
  payload: {
    images: content,
  }
});

export const deleteUploadedImage = (content) => ({
  type: ActionTypes.DELETE_UPLOADED_IMAGE,
  payload: {
    fileId: content.fileId,
  }
});

export const deleteImage = (id) => ({
  type: ActionTypes.DELETE_IMAGE,
  payload: {
    id,
  }
});

export const addProcessingImage = (content) => ({
  type: ActionTypes.ADD_PROCESSING_IMAGE,
  payload: {
    fileId: content.fileId,
    id: content.id,
  }
});

export const addProcessedImage = (content) => ({
  type: ActionTypes.ADD_PROCESSED_IMAGE,
  payload: {
    ...content,
  }
});

export const updateObjectCount = (content) => ({
  type: ActionTypes.UPDATE_OBJECT_COUNT,
  payload: {
    ...content,
  }
});
